export default __webpack_public_path__ + "static/media/statusStub.54f1eac5.svg";